'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.secondFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/secondFromNow.js
// module id = 733
// module chunks = 0